var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpecialChars = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.246 14.429q-.515 0-.883-.366a1.2 1.2 0 0 1-.369-.886c0-.347.123-.631.369-.874q.368-.364.883-.364a1.2 1.2 0 0 1 .874.364q.378.364.378.874 0 .346-.175.631-.176.284-.458.453a1.2 1.2 0 0 1-.619.168M4.46 4.426l-.221 6.843h-1.98l-.221-6.843zM8.066 12.437a1.17 1.17 0 0 0-.363.874q-.005.52.363.887.166.165.364.255a4.687 4.687 0 0 1 .449-2.377 1.2 1.2 0 0 0-.813.361m4.048-6.793q-.442-.601-1.216-.91-.773-.308-1.765-.308a4.3 4.3 0 0 0-1.657.31 2.7 2.7 0 0 0-1.206.957q-.455.645-.47 1.656h2.216q.005-.337.161-.575.157-.24.405-.369a1.1 1.1 0 0 1 .532-.13q.284 0 .518.118a.9.9 0 0 1 .368.335.93.93 0 0 1 .135.501c0 .19-.046.37-.14.525a1.8 1.8 0 0 1-.378.431q-.239.2-.541.392a3.2 3.2 0 0 0-.646.542q-.264.297-.402.783t-.137 1.304v.198h1.382q.33-.47.761-.844.014-.04.029-.078.12-.296.358-.528.24-.23.6-.443.462-.274.807-.609.344-.334.537-.773a2.5 2.5 0 0 0 .193-1.01q0-.873-.444-1.475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBB17",
    d: "M13.343 10.85a3.26 3.26 0 1 0 0 6.521 3.26 3.26 0 0 0 0-6.52m1.553 4.912a.39.39 0 0 1-.388.389h-2.332a.39.39 0 0 1-.388-.389v-1.943a.39.39 0 0 1 .388-.388h.195v-.389a.971.971 0 1 1 1.942 0v.39h.195c.213 0 .388.174.388.387zm-1.554-3.322a.603.603 0 0 0-.603.602v.39h1.206v-.39a.603.603 0 0 0-.603-.602m0 1.962a.39.39 0 0 0-.388.389.389.389 0 1 0 .389-.389",
    className: "lock"
  })));
};
export default SvgSpecialChars;